<div class="health-nav">
  @for (tab of tabs; track tab.route) {
    @if (tab.visible) {
      @if (tab.setApart) {
        <span class="health-nav-divider"></span>
      }
      <a mat-raised-button class="health-nav-tab" [class.health-nav-tab-external]="tab.setApart"
        routerLinkActive="active-tab"
        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }"
        [routerLink]="[tab.route]" [queryParams]="{ storeNumber: storeNumber }"
        color="secondary" [attr.id]="tab.id">
        {{ tab.label }}
      </a>
    }
  }
</div>
